import {FC} from 'react';
import {
  ServiceRequestStatusesByDate,
  ServiceRequestStatusesByDateColors,
  ServiceRequestStatusesByDateLabels,
} from '../../../Dashboard/dashboard/AdminDashboard/constants/service-requests-statuses-by-date';
import {statusCircleStyles as STYLES} from './ServiceRequestStatusColorCircle.styles';
import {Box} from '@mui/material';

interface Props {
  status?: ServiceRequestStatusesByDate;
  withLabel?: boolean;
  archived?: boolean;
}

export const ServiceRequestStatusColorCircle: FC<Props> = ({status, withLabel, archived}) => {
  if (!status) {
    return null;
  }

  const color = archived ? '#A8ACB0' : ServiceRequestStatusesByDateColors[status];

  return (
    <Box sx={STYLES.container}>
      <Box sx={STYLES.circle(color)} />
      {withLabel && <Box>{ServiceRequestStatusesByDateLabels[status]}</Box>}
    </Box>
  );
};
